import {
  CheckCircle as CheckCircleIcon,
  Organization as OrganizationIcon,
  ThumbsUp as ThumbsUpIcon,
} from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

import { BuildingBlock } from 'modules/workflows/components/WorkflowBuildingBlocksBox'

export const getBuildingBlocks = (): BuildingBlock[] => {
  return [
    {
      key: 'condition',
      nodeType: 'condition',
      title: i18n.t('workflows.building_blocks.condition.title'),
      description: i18n.t('workflows.building_blocks.condition.description'),
      color: '#07A2AD',
      background: '#CDECEF80',
      icon: OrganizationIcon,
    },
    {
      key: 'task',
      nodeType: 'task',
      title: i18n.t('workflows.building_blocks.task.title'),
      description: i18n.t('workflows.building_blocks.task.description'),
      color: '#47A7FF',
      background: '#CCE6FF80',
      icon: CheckCircleIcon,
    },
    {
      key: 'approvals',
      nodeType: 'approvals',
      title: i18n.t('workflows.building_blocks.approval.title'),
      description: i18n.t('workflows.building_blocks.approval.description'),
      color: '#6156ED',
      background: '#6156ED20',
      icon: ThumbsUpIcon,
    },
  ]
}
